/**
 * Normalizes mapped API opportunity objects for investor detail UI.
 * Uses API/public_content fields only — no seeded or category-based fallbacks.
 */
export function enrichOpportunity(opportunity) {
  if (!opportunity) return null;

  const totalUnits = Number(opportunity.totalUnits) || 0;
  const availableUnits = Number(opportunity.availableUnits) || 0;
  const fundedAmount = Number(opportunity.fundedAmount) || 0;
  const fundingTarget = Number(opportunity.fundingTarget) || 0;

  let fundedPct = Number(opportunity.fundedPct);
  if (!Number.isFinite(fundedPct)) {
    if (fundingTarget > 0) {
      fundedPct = Math.round((fundedAmount / fundingTarget) * 100);
    } else if (totalUnits > 0) {
      fundedPct = Math.round(((totalUnits - availableUnits) / totalUnits) * 100);
    } else {
      fundedPct = 0;
    }
  }
  fundedPct = Math.min(100, Math.max(0, fundedPct));

  const payoutType = opportunity.payoutType
    ? String(opportunity.payoutType).replace(/_/g, " ")
    : "";

  return {
    ...opportunity,
    name: opportunity.name || opportunity.title || "Investment opportunity",
    description: opportunity.description || opportunity.fullDescription || "",
    marketingDescription:
      opportunity.marketingDescription || opportunity.description || opportunity.fullDescription || "",
    providerName: opportunity.providerName || "—",
    opportunityStatus:
      opportunity.opportunityStatus || (availableUnits > 50 ? "Open" : "Closing soon"),
    unitPriceNgn: Number(opportunity.unitPriceNgn) || 0,
    availableUnits,
    totalUnits: totalUnits || availableUnits || 0,
    expectedReturnPct: Number(opportunity.expectedReturnPct) || 0,
    durationMonths: Number(opportunity.durationMonths) || 0,
    minUnitsPurchase: Number(opportunity.minUnitsPurchase) || 1,
    maxUnitsPurchase: Number(opportunity.maxUnitsPurchase) || 1,
    currentValuePerUnit: opportunity.currentValuePerUnit ?? (Number(opportunity.unitPriceNgn) || 0),
    fundedPct,
    fundedAmount,
    fundingTarget,
    overview: opportunity.overview || {},
    howItWorks: opportunity.howItWorks || [],
    highlights: opportunity.highlights || [],
    gallery: opportunity.gallery || [],
    fundingTimeline: opportunity.fundingTimeline || [],
    updates: opportunity.updates || [],
    documents: opportunity.documents || [],
    faqs: opportunity.faqs || [],
    support: opportunity.support || {},
    riskDisclaimer:
      opportunity.riskDisclaimer ||
      "Past or projected returns are not guaranteed. Review all documents and terms before investing.",
    repaymentPlan: opportunity.repaymentPlan || payoutType || "—",
    payoutType: payoutType || "—",
    investmentType: opportunity.investmentType || opportunity.category || "Investment",
    earlyExitPolicy: opportunity.earlyExitPolicy || "Not specified",
    currency: opportunity.currency || "NGN",
    heroGradient:
      opportunity.heroGradient ||
      "linear-gradient(135deg, rgba(139, 49, 58, 0.5) 0%, rgba(49, 119, 140, 0.35) 100%)",
    isVerified: opportunity.isVerified ?? true,
  };
}

